import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useRentmanData } from './useRentmanData';

export function useRentmanCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();
  const { data: rentmanData, loading: rentmanLoading, error: rentmanError } = useRentmanData();

  useEffect(() => {
    if (rentmanLoading) {
      setLoading(true);
      return;
    }

    if (rentmanError) {
      setError(rentmanError);
      setLoading(false);
      return;
    }

    if (rentmanData?.customers) {
      setCustomers(rentmanData.customers);
      setLoading(false);
    } else {
      setError("No customer data available");
      setLoading(false);
    }
  }, [rentmanData, rentmanLoading, rentmanError]);

  return { customers, loading, error };
} 